






import { Component, Vue, Prop } from "vue-property-decorator";
import { ChartColors, ChartConstants } from "@/constants/chart";
import { ComparativeScoreChartDTO } from "@/api/analyses/types";


@Component({
  name: "ComparativeScoreRender",
})
export default class ComparativeScoreRender extends Vue {

  @Prop({ type: Array, required: true })
  private comparativeScoreList!: ComparativeScoreChartDTO[];

  @Prop({ type: String, required: false })
  private title!: string;

  private getLabels(list: ComparativeScoreChartDTO[]) {
    return list.map(item => item.analysisYear);
  }

  get chartOptions() {
    return {
      chart: {
        style: {
          fontFamily: ChartConstants.FONT_FAMILY
        },
        backgroundColor: ChartColors.BACKGROUND,
      },
      credits: {
        enabled: false,
      },
      title: {
        text: this.title,
        style: ChartConstants.TITLE_STYLE,
        align: 'left'
      },
      xAxis: {
        categories: this.getLabels(this.comparativeScoreList),
      },
      yAxis: {
        title: {
            text: ''
        }
      },
      legend: {
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'top'
      },

      plotOptions: {
        series: {
            label: {
                connectorAllowed: false
            },
        }
      },
      series: this.getData(this.comparativeScoreList),

      responsive: {
        rules: [{
          condition: {
            maxWidth: 500
          },
          chartOptions: {
            legend: {
              layout: 'horizontal',
              align: 'center',
              verticalAlign: 'bottom'
            }
          }
        }]
      }
    };
  }


  private getData(list: ComparativeScoreChartDTO[]) {
    const data1 = {
      name: this.$t("charts.comparative-score.score-city"),
      backgroundColor: ChartColors.WHITE,
      color: ChartColors.WHITE,
      yAxisID: "y-axis-1",
      data: list.map((item) => item.scoreCity),
      fill: false,
    };

    const data2 = {
      name: this.$t("charts.comparative-score.score-micro-region"),
      backgroundColor: ChartColors.YELLOW,
      color: ChartColors.YELLOW,
      yAxisID: "y-axis-2",
      data: list.map((item) => item.scoreMicroRegion),
      fill: false,
    };

    const data3 = {
      name: this.$t("charts.comparative-score.score-state"),
      backgroundColor: ChartColors.BLUE_LIGHT,
      color: ChartColors.BLUE_LIGHT,
      yAxisID: "y-axis-3",
      data: list.map((item) => item.scoreState),
      fill: false,
    };

    const data4 = {
      name: this.$t("charts.comparative-score.score-country"),
      backgroundColor: ChartColors.GREEN,
      color: ChartColors.GREEN,
      yAxisID: "y-axis-4",
      data: list.map((item) => item.scoreCountry),
      fill: false,
    };

    return [data1, data2, data3, data4];
  }
}

